<template>
  <b-overlay :show="busy" rounded="sm">
    <b-card class="border-none py-0 mb-0 no-margin px-1">
      <!-- {{ id }}
      {{ disabled }} -->
      <!-- <div >
        <b-card > -->
      <b-card-header class="py-1 mb-2">
        <i :class="options.icon" class="text-primary mr-1"></i>
        {{ item.ref }}
        <span class="text-warning"
          >&lt;{{ search.selected.addRow ? "new" : "edit" }}&gt;</span
        >
      </b-card-header>
      <b-card-body class="mt-2 py-0">
        <b-row>
          <b-col cols="12" sm="6" md="3" xl="3">
            <b-form-group label="Entry" label-for="entry" label-cols="12">
              <b-input-group>
                <b-form-input
                  type="text"
                  v-model="credit.entry"
                  placeholder="Entry"
                  size="sm"
                  :disabled="true"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    :disabled="true"
                    variant="outline-secondary"
                    @click="item.entry = ''"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="3" xl="3">
            <b-form-group label="Ref" label-for="ref" label-cols="12">
              <b-input-group>
                <b-form-input
                  type="text"
                  v-model="credit.ref"
                  placeholder="<new ref>"
                  size="sm"
                  :disabled="true"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    :disabled="true"
                    variant="outline-secondary"
                    @click="item.ref = ''"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="3" xl="3">
            <b-form-group label-cols="12" label="Ref Date" label-size="sm">
              <b-input-group>
                <b-form-datepicker
                  v-model="credit.dateref"
                  size="sm"
                  label-help
                  hide-header
                  locale="en-GB"
                  placeholder="Select date"
                  :date-format-options="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                  }"
                ></b-form-datepicker>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    @click="credit.dateref = null"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="6" md="3" xl="3">
            <b-form-group label-cols="12" label="Agent" label-size="sm">
              <b-input-group>
                <b-form-input
                  v-model="credit.agent"
                  placeholder="Agent"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    @click="credit.agent = ''"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="1">
            <b-button
              size="sm"
              squared
              variant="outline-primary"
              @click="toggleExpand()"
            >
              <i :class="expanded ? 'fa fa-compress' : 'fa fa-expand'"></i>
            </b-button>
          </b-col>
          <b-col cols="11">
            <div class="availtable datatable nested">
              <b-table
                :dark="$store.state.darkMode"
                ref="grid"
                sticky-header="350px"
                striped
                hover
                small
                caption-bottom
                selectable
                select-mode="single"
                :busy="busy"
                :items="griditems"
                :fields="gridfields"
                @row-clicked="rowClicked"
              >
                <template v-slot:table-busy>
                  <div class="text-center my-2">
                    <b-spinner
                      variant="primary"
                      class="align-middle mr-2"
                    ></b-spinner>
                    <strong class="text-primary">Loading...</strong>
                  </div>
                </template>
                <template v-slot:cell(icon)>
                  <i :class="options.icon" class="text-primary"></i>
                </template>
                <template #cell(selected)="{ rowSelected }">
                  <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                  </template>
                  <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                  </template>
                </template>
                <template v-if="options.actions" v-slot:cell(actions)="row">
                  <div id="actions-container" v-if="options.actions_as_elipses">
                    <b-button
                      variant="link"
                      size="sm"
                      title="Actions"
                      :id="'popover-target-' + row.item.id"
                      @click="$root.$emit('bv::hide::popover')"
                    >
                      <i class="fa fa-ellipsis-h text-primary"></i>
                    </b-button>
                    <b-popover
                      container="actions-container"
                      triggers="click blur"
                      placement="leftbottom"
                      :target="'popover-target-' + row.item.id"
                    >
                      <div>
                        <b-nav vertical>
                          <b-nav-item
                            :title="action.label"
                            v-for="action in $helpers.actionsValid(
                              row.item,
                              options
                            )"
                            :key="action.key"
                            @click.stop="table_action(action.key, row)"
                          >
                            <b-row class="px-2">
                              <b-col class="px-0">
                                <span class="text-normal">{{
                                  action.label
                                }}</span>
                              </b-col>
                              <b-col cols="1">
                                <i
                                  :class="action.icon"
                                  class="text-primary"
                                ></i>
                              </b-col>
                            </b-row>
                          </b-nav-item>
                        </b-nav>
                      </div>
                    </b-popover>
                  </div>
                  <div v-else>
                    <b-button
                      variant="link"
                      size="sm"
                      v-for="action in $helpers.actionsValid(row.item, options)"
                      :key="action.key"
                      @click.stop="table_action(action.key, row)"
                      :title="action.label"
                    >
                      <i :class="action.icon" class="text-primary"></i>
                    </b-button>
                  </div>
                </template>

                <template v-slot:row-details="row">
                  <b-card>
                    <component
                      :is="options.component.name"
                      :search="search"
                      @discard="discard(row)"
                      @refresh="refresh()"
                    ></component>
                  </b-card>
                </template>
                <template v-slot:bottom-row>
                  <td v-for="index in 9" :key="index"></td>
                  <td class="text-danger"><strong>Total</strong></td>
                  <td class="text-right text-danger strong">
                    {{ (credit.costtotal * -1) | currency("") }}
                  </td>
                  <td class="text-right text-danger strong">
                    {{ (credit.taxes * -1) | currency("") }}
                  </td>
                  <td class="text-right text-danger strong">
                    {{ (credit.fees * -1) | currency("") }}
                  </td>
                  <td class="text-right text-danger strong">
                    {{ (credit.saletotal * -1) | currency("") }}
                  </td>
                </template>
              </b-table>
            </div>
          </b-col>
        </b-row>

        <div v-if="expanded">
          <b-row>
            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group label="Name/Route" label-for="name" label-cols="12">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="lineitem.name"
                    placeholder="Name"
                    size="sm"
                    :disabled="false"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      :disabled="false"
                      variant="outline-secondary"
                      @click="lineitem.name = ''"
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group
                label-cols="12"
                label="Client SL A/C"
                label-size="sm"
              >
                <treeselect
                  placeholder="Select slac..."
                  searchPromptText="Type at least 3 chars..."
                  v-model="lineitem.slac"
                  :clearable="true"
                  :async="true"
                  :load-options="treeselect_loadSLAC"
                  :show-count="true"
                  :flatten-search-results="true"
                  :disable-branch-nodes="true"
                  :matchKeys="['id']"
                  search-nested
                  :disabled="false"
                >
                  <div slot="value-label" slot-scope="{ node }">
                    {{ node.raw.id }}
                  </div>
                </treeselect>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group
                label-cols="12"
                label="Supplier B/L"
                label-size="sm"
              >
                <treeselect
                  placeholder="Select blac..."
                  searchPromptText="Type at least 3 chars..."
                  v-model="lineitem.blac"
                  :clearable="true"
                  :async="true"
                  :load-options="treeselect_loadBLAC"
                  :show-count="true"
                  :flatten-search-results="true"
                  :disable-branch-nodes="true"
                  :matchKeys="['id']"
                  search-nested
                  :disabled="false"
                >
                  <div slot="value-label" slot-scope="{ node }">
                    {{ node.raw.id }}
                  </div>
                </treeselect>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group
                label-cols="12"
                label="Date Travel"
                label-size="sm"
                :disabled="false"
              >
                <b-input-group>
                  <b-form-datepicker
                    v-model="lineitem.datetravel"
                    size="sm"
                    label-help
                    hide-header
                    locale="en-GB"
                    placeholder="Select date"
                    :disabled="false"
                    :date-format-options="{
                      year: 'numeric',
                      month: 'numeric',
                      day: 'numeric',
                    }"
                  ></b-form-datepicker>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      @click="lineitem.datetravel = null"
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group
                label="Ticket No"
                label-for="ticketno"
                label-cols="12"
              >
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="lineitem.ticketno"
                    placeholder="Ticket No"
                    size="sm"
                    :disabled="false"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      :disabled="false"
                      variant="outline-secondary"
                      @click="lineitem.ticketno = ''"
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group
                label="Passenger"
                label-for="passenger"
                label-cols="12"
              >
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="lineitem.passenger"
                    placeholder="Passenger"
                    size="sm"
                    :disabled="false"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      :disabled="false"
                      variant="outline-secondary"
                      @click="lineitem.passenger = ''"
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6" md="4" xl="2">
              <b-form-group label="QTY" label-for="qty" label-cols="12">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="lineitem.qty"
                    placeholder="QTY"
                    size="sm"
                    :disabled="false"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      :disabled="false"
                      variant="outline-secondary"
                      @click="lineitem.qty = ''"
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6" md="4" xl="2">
              <b-form-group
                label="Cost Ex VAT"
                label-for="costexvat"
                label-cols="12"
              >
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="lineitem.costexvat"
                    placeholder="Cost Ex VAT"
                    size="sm"
                    :disabled="false"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      :disabled="false"
                      variant="outline-secondary"
                      @click="lineitem.costexvat = ''"
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6" md="4" xl="2">
              <b-form-group
                label="Cost VAT"
                label-for="costvat"
                label-cols="12"
              >
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="lineitem.costvat"
                    placeholder="Cost VAT"
                    size="sm"
                    :disabled="false"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      :disabled="false"
                      variant="outline-secondary"
                      @click="lineitem.costvat = ''"
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6" md="4" xl="2">
              <b-form-group
                label="Cost Total"
                label-for="costtotal"
                label-cols="12"
              >
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="lineitem.costtotal"
                    placeholder="Cost Total"
                    size="sm"
                    :disabled="false"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      :disabled="false"
                      variant="outline-secondary"
                      @click="lineitem.costtotal = ''"
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6" md="4" xl="2">
              <b-form-group label="Taxes" label-for="taxes" label-cols="12">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="lineitem.taxes"
                    placeholder="Taxes"
                    size="sm"
                    :disabled="false"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      :disabled="false"
                      variant="outline-secondary"
                      @click="lineitem.taxes = ''"
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6" md="4" xl="2">
              <b-form-group label="Fees" label-for="fees" label-cols="12">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="lineitem.fees"
                    placeholder="Fees"
                    size="sm"
                    :disabled="false"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      :disabled="false"
                      variant="outline-secondary"
                      @click="lineitem.fees = ''"
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6" md="4" xl="2">
              <b-form-group
                label="Sale Ex VAT"
                label-for="saleexvat"
                label-cols="12"
              >
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="lineitem.saleexvat"
                    placeholder="Sale Ex VAT"
                    size="sm"
                    :disabled="false"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      :disabled="false"
                      variant="outline-secondary"
                      @click="lineitem.saleexvat = ''"
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6" md="4" xl="2">
              <b-form-group
                label="Sale VAT"
                label-for="salevat"
                label-cols="12"
              >
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="lineitem.salevat"
                    placeholder="Sale VAT"
                    size="sm"
                    :disabled="false"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      :disabled="false"
                      variant="outline-secondary"
                      @click="lineitem.salevat = ''"
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6" md="4" xl="2">
              <b-form-group
                label="Sale Total"
                label-for="saletotal"
                label-cols="12"
              >
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="lineitem.saletotal"
                    placeholder="Sale Total"
                    size="sm"
                    :disabled="false"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      :disabled="false"
                      variant="outline-secondary"
                      @click="lineitem.saletotal = ''"
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
        <b-row>
          <b-col cols="12">
            <b-form-group
              label="Comments to be saved with original invoice"
              label-for="comments"
              label-cols="12"
            >
              <b-form-textarea
                id="data"
                v-model="credit.comments"
                placeholder="Comments"
                rows="2"
                class="smalltextarea"
              ></b-form-textarea>
            </b-form-group> </b-col
        ></b-row>
      </b-card-body>

      <b-card-footer class="mt-2 ml-1">
        <b-row>
          <b-col class="text-left">
            <div v-if="busy">
              <i class="fa fa-spinner fa-spin text-primary"></i>
            </div>
            <div v-else>
              <span v-html="message"></span>
            </div>
          </b-col>
          <b-col class="text-right" cols="8">
            <b-button
              squared
              size="sm"
              variant="secondary"
              class="mr-1"
              @click="discard"
            >
            <i class="fa fa-chevron-left pr-1"></i>
              Back
            </b-button>
            <b-button
              squared
              size="sm"
              variant="primary"
              @click="save()"
              v-if="
                user.rolename == 'admin' 
              "
            >
              <i class="fa fa-check"></i>
              Post It
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
    <!-- </div>
    </b-card> -->
  </b-overlay>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";

export default {
  components: {},
  name: "SLCreditItem",
  props: ["search"],
  watch: {
    search: {
      immediate: true,
      async handler(newVal, oldVal) {
        console.log("watch:search", newVal);
        this.message = null;
        if (newVal) {
          if (newVal.selected.addRow) {
            this.id = null;
            this.disabled = false;
            this.addRow();
          } else {
            this.id = newVal.selected.id;
            this.disabled = true;
            this.load();
          }
        }
        await this.loadDDL();
      },
    },
    "credit.reason": {
      async handler(newVal, oldVal) {
        console.log("watch:credit.reason", newVal);
        if (newVal) {
          switch (this.credit.reason) {
            case "RF":
              this.$set(this.credit, "refund", "REFUND");
              break;
            case "VD":
              this.$set(this.credit, "refund", "VOID");
              break;
          }
        }
      },
    },
  },
  mounted() {
    this.item.agent = this.user.initials;
  },
  data() {
    return {
      busy: false,
      message: "",
      expanded: false,
      griditems: [],
      gridfields: [],
      requirement: {},
      reason_options: [
        { id: "BT", label: "BTA | Card Error" },
        { id: "OE", label: "OE | Operator Error" },
        { id: "RF", label: "RF | Refund" },
        { id: "RI", label: "RI | Reinvoice" },
        { id: "ST", label: "ST | Staff Travel" },
        { id: "VD", label: "VD | Void" },
      ],
      salecode_options: [
        {
          id: "CI",
          label: "CI | Commissionable Item",
        },
        {
          id: "DT",
          label: "DT | Domestic Ticket",
        },
        {
          id: "IT",
          label: "IT | International Ticket",
        },
        {
          id: "MT",
          label: "MT | Miscellaneous Item",
        },
        {
          id: "MU",
          label: "MU | Marked Up Item",
        },
        {
          id: "NF",
          label: "NF | Net Fare",
        },
        {
          id: "NN",
          label: "NN | Net Net Remit",
        },
        {
          id: "TF",
          label: "TF | Transaction Fee Item",
        },
        {
          id: "UK",
          label: "UK | Marked Up Item (UK With VAT)",
        },
        {
          id: "VI",
          label: "VI | Commissionable Item (UK With VAT)",
        },
      ],
      credit: {
        reason: "RF",
        refund: "REFUND",
        comments: "",
        autocredit: true,
        creditbl: false,
        creditfees: false,
        creditzhold: false,
        salecode: "MU",
      },
      lineitem: {},
      item: {
        type: "A",
        datetax: this.$moment().format("YYYY-MM-DD"),
        datedepart: this.$moment().format("YYYY-MM-DD"),
        slac: null,
        agent: null,
        ticketno: null,
        items: [{ name: "Passenger 1", ticketno: "abc", id: 0 }],
      },
      options: {
        title: "Edit Line Item",
        icon: "fa fa-gbp",
        debounce: 500,
        collapsedfields: [
          {
            key: "empty1",
            label: "x",
            class: "text-center w-120px",
          },
          {
            key: "empty2",
            label: "x",
            class: "text-center w-200px",
          },
          {
            key: "costtotal",
            label: "Price",
            sortable: true,
            class: "text-right",
            formatter: (value, key, item) => {
              if (value) {
                return parseFloat(value).toFixed(2);
              } else {
                return value;
              }
            },
          },

          {
            key: "taxes",
            label: "Taxes",
            sortable: true,
            class: "text-right",
            formatter: (value, key, item) => {
              if (value) {
                return parseFloat(value).toFixed(2);
              } else {
                return value;
              }
            },
          },
          {
            key: "fees",
            label: "Fees",
            sortable: true,
            class: "text-right",
            formatter: (value, key, item) => {
              if (value) {
                return parseFloat(value).toFixed(2);
              } else {
                return value;
              }
            },
          },
          {
            key: "saletotal",
            label: "Sale",
            sortable: true,
            class: "text-right",
            formatter: (value, key, item) => {
              if (value) {
                return parseFloat(value).toFixed(2);
              } else {
                return value;
              }
            },
          },
          {
            key: "actions",
            label: "Actions",
            class: "actions w-100px w-sm-100pct",
          },
        ],
        expandedfields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-center w-30px",
          },
          {
            key: "line",
            label: "#",
            sortable: true,
            class: "d-none d-sm-table-cell",
          },

          {
            key: "name",
            label: "Name",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },

          {
            key: "slac",
            label: "SL A/C",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "datetravel",
            label: "Date Travel",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = this.$moment(value).format("DD/MM/YYYY");
              }
              return result;
            },
          },
          {
            key: "ticketno",
            label: "Ticket#",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "passenger",
            label: "Passenger",
            sortable: true,
            class: "d-none d-sm-table-cell",
          },
          {
            key: "blac",
            label: "BL A/C",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "qty",
            label: "Qty",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "costtotal",
            label: "Price",
            sortable: true,
            class: "text-right",
            formatter: (value, key, item) => {
              if (value) {
                return parseFloat(value).toFixed(2);
              } else {
                return value;
              }
            },
          },

          {
            key: "taxes",
            label: "Taxes",
            sortable: true,
            class: "text-right",
            formatter: (value, key, item) => {
              if (value) {
                return parseFloat(value).toFixed(2);
              } else {
                return value;
              }
            },
          },
          {
            key: "fees",
            label: "Fees",
            sortable: true,
            class: "text-right",
            formatter: (value, key, item) => {
              if (value) {
                return parseFloat(value).toFixed(2);
              } else {
                return value;
              }
            },
          },
          {
            key: "saletotal",
            label: "Sale",
            sortable: true,
            class: "text-right",
            formatter: (value, key, item) => {
              if (value) {
                return parseFloat(value).toFixed(2);
              } else {
                return value;
              }
            },
          },
          {
            key: "actions",
            label: "Actions",
            class: "actions w-100px w-sm-100pct",
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(["window", "user", "events"]),
    readonly() {
      return true;
    },
    // editable() {
    //   if (
    //     this.user.rolename == "admin"
    //   ) {
    //     return false;
    //   } else {
    //     return true;
    //   }
    // },
  },
  methods: {
    async loadDDL() {
      console.log("loadDDL");
      this.gridfields = this.options.expandedfields;
    },
    async load() {
      let variables = {
        id: this.id,
      };
      console.log("variables", variables);
      if (!this.id) {
        return;
      }

      this.busy = true;

      try {
        const response = await this.$apollo.query({
          query: gql`
            query SLTransactions($id: String) {
              SLTransactions(id: $id) {
                id
                credit
                ref
                dateref
                yourref
                refcredit
                slac
                eventcode
                passenger
                datetravel
                costtotal
                taxes
                fees
                saleexvat
                salevat
                saletotal
                outstanding
                datedue
                datepaid
                cancelled
                notes
                comments
                typeinv
                agent
                items {
                  id
                  line
                  name
                  slac
                  blac
                  datetravel
                  route
                  niceroute
                  ticketno
                  passenger
                  nicename
                  qty
                  costexvat
                  costvat
                  costtotal
                  taxes
                  fees
                  saleexvat
                  salevat
                  saletotal
                }
              }
            }
          `,
          variables,
        });

        console.log(response.data.SLTransactions);
        this.item = response.data.SLTransactions[0];

        this.item.dateref = this.$helpers.datefield(this.item.dateref);
        this.item.datetravel = this.$helpers.datefield(this.item.datetravel);
        this.item.datedue = this.$helpers.datefield(this.item.datedue);
        this.item.datepaid = this.$helpers.datefield(this.item.datepaid);

        // PREPARE COPY CREDIT OBJECT
        this.credit = { ...this.item };
        this.$set(this.credit, "reason", "RF");
        this.$set(this.credit, "autocredit", true);
        this.credit.salecode = "MU";
        this.credit.refund = "REFUND";
        this.credit.comments = "";
        this.credit.creditbl = true;
        this.credit.creditfees = true;
        this.credit.creditzhold = false;
        for (var j = 0; j < this.credit.items.length; ++j) {
          this.credit.items[j].datetravel = this.$helpers.datefield(
            this.credit.items[j].datetravel
          );
          this.credit.items[j].qty = parseFloat(this.credit.items[j].qty) * -1;
          this.credit.items[j].costexvat =
            parseFloat(this.credit.items[j].costexvat) * -1;
          this.credit.items[j].costvat =
            parseFloat(this.credit.items[j].costvat) * -1;
          this.credit.items[j].costtotal =
            parseFloat(this.credit.items[j].costtotal) * -1;
          this.credit.items[j].taxes =
            parseFloat(this.credit.items[j].taxes) * -1;
          this.credit.items[j].fees =
            parseFloat(this.credit.items[j].fees) * -1;
          this.credit.items[j].saleexvat =
            parseFloat(this.credit.items[j].saleexvat) * -1;
          this.credit.items[j].salevat =
            parseFloat(this.credit.items[j].salevat) * -1;
          this.credit.items[j].saletotal =
            parseFloat(this.credit.items[j].saletotal) * -1;
        }
        this.lineitem = this.credit.items[0];
      } catch (error) {
        console.log(error);
      }

      this.busy = false;
    },
    async save() {
      this.busy = true;

      let row = { ...this.item };
      delete row.__typename;
      delete row._showDetails;
      delete row.id;

      row = {
        notes: this.item.notes,
        comments: this.item.comments,
        eventcode: this.item.eventcode,
        yourref: this.item.yourref,
        slac: this.item.slac,
      };

      let variables = {
        id: this.id ? this.id.toString() : "0",
        row,
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation saveSLTransaction($id: String, $row: SLInvoice_input) {
              saveSLTransaction(id: $id, row: $row) {
                id
              }
            }
          `,
          variables,
        });
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }
      this.busy = false;

      await this.$emit("refresh");
    },
    async rowClicked(item) {
      console.log("row clicked", item);
      this.lineitem = item;
      //   // DEFAULT COMPONENT IS THE FIRST ONE
      //   if (this.options.actions.length > 0) {
      //     if (this.options.actions[0].component) {
      //       this.options.component = this.options.actions[0].component;
      //     }
      //   }

      //   this.search.selected = item;
      //   let lo = -1;
      //   // CLOSE ALL
      //   for (var k = 0; k < this.items.length; k++) {
      //     if (this.items[k]._showDetails) {
      //       lo = k;
      //     }
      //     this.$set(this.items[k], "_showDetails", false);
      //   }
      //   item._showDetails = lo == item.ID ? false : true;
    },
    toggleExpand() {
      if (this.expanded) {
        this.gridfields = this.options.expandedfields;
        this.griditems = [];
        this.expanded = false;
      } else {
        this.gridfields = this.options.expandedfields;
        this.griditems = this.credit.items;
        this.expanded = true;
        this.$refs.grid.selectAllRows();
      }
    },
    discard() {
      this.$emit("discard", null);
    },
  },
};
</script>


